module.exports = __webpack_public_path__ + "img/logo.3f515cd1.png";